import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TwoToneIcons from './TwoToneIcons';
import ClientProvider from './client';
export default createDemo(import.meta.url, TwoToneIcons, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/icons/demos/two-tone/TwoToneIcons.tsx",
    "fileName": "TwoToneIcons.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { useTheme } from '@mui/material/styles';\nimport Icon from '@mui/material/Icon';\n\nconst useIsDarkMode = () => {\n  const theme = useTheme();\n  return theme.palette.mode === 'dark';\n};\n\nexport default function TwoToneIcons() {\n  const isDarkMode = useIsDarkMode();\n\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Icon\n      sx={[isDarkMode && { filter: 'invert(1)' }]}\n      baseClassName=\"material-icons-two-tone\"\n    >\n      add_circle\n    </Icon>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 20,
        "focusedLines": 6,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { useTheme } from '@mui/material/styles';\nimport Icon from '@mui/material/Icon';\n\nconst useIsDarkMode = () => {\n  const theme = useTheme();\n  return theme.palette.mode === 'dark';\n};\n\nexport default function TwoToneIcons() {\n  const isDarkMode = useIsDarkMode();\n\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <Icon\n      sx={[isDarkMode && { filter: 'invert(1)' }]}\n      baseClassName=\"material-icons-two-tone\"\n    >\n      add_circle\n    </Icon>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 13
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 14
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "[",
              [
                "span",
                "pl-smi di-jv",
                "isDarkMode"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "&&"
              ],
              " { ",
              [
                "span",
                "di-op di-jv",
                "filter"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "invert(1)",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }]",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 15
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "baseClassName"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "material-icons-two-tone",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 16
            },
            "    >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            "      add_circle"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "Icon"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 20,
    "focusedLines": 6,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Icon"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
